export const TAB_IDS = {
  OVERVIEW: 'overview',
  TRIPS: 'trips',
  REVENUE: 'revenue',
  BREAKDOWN: 'breakdown',
  DRIVER_DIGEST: 'driver-digest',
  TIMELINESS: 'timeliness'
};

export const REPORT_TABS = [
  { id: TAB_IDS.OVERVIEW, label: 'Overview' },
  { id: TAB_IDS.TRIPS, label: 'Trips' },
  { id: TAB_IDS.REVENUE, label: 'Revenue' },
  { id: TAB_IDS.BREAKDOWN, label: 'Breakdown' },
  { id: TAB_IDS.DRIVER_DIGEST, label: 'Driver Digest' },
  { id: TAB_IDS.TIMELINESS, label: 'Timeliness' }
];

export function getTabLabel(tabId: string): string {
  const tab = REPORT_TABS.find((t) => t.id === tabId);
  return tab ? tab.label : 'Business Reports';
}
